import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-map',
  imports: [],
  templateUrl: './icon-bold-map.component.html',
})
export class IconBoldMapComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24';
}
